import { Fragment, useEffect } from 'react';
import ReactPlayer from 'react-player';

export interface IModal {
    type: 'image' | 'video' | 'text';
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    data: {
        url: string;
        width: number;
        height: number;
        title?: string;
    }
}

const ModalContent = ({ type, data, isOpen }: Partial<IModal>) => {
    switch(type) {
        case 'image':
            return <img src={data?.url} alt={data?.title} />;
        case 'video':
            return isOpen ? <ReactPlayer url={data?.url} controls={true} width="100%" height="100%"/> : <Fragment />;
        default:
            return <Fragment />
        
    }
};

export const Modal = ({ type, isOpen, setIsOpen, data }: IModal) => {
    const clickBgCallback = () => {
        setIsOpen(false);
    };
    
    return data?.url ? <div className={`modal-wrap ${type} ${isOpen ? 'active' : ''}`} onClick={clickBgCallback}>
        <div className="modal">
            <ModalContent data={data} type={type} isOpen={isOpen} />
        </div>
    </div> : <Fragment />;
};